<div class="modal-body">
    <form *ngIf="modalState === 'query'">
      <div
        *ngIf="isLoading"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgb(250, 248, 248);
        "
      >
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </div>
      <div *ngIf="!isLoading">
        <div class="text-center">
          <label
            [innerHTML]="'CARDOPERATIONS_CARD_INPUT_HEADER_LABEL' | translate"
          ></label>
          <br />
          <small
            class="text-muted"
            [innerHTML]="'CARDOPERATIONS_CARD_INPUT_DETAIL_LABEL' | translate"
          ></small>
          <div class="spacer10"></div>
          <input
            #box
            type="text"
            class="input-lg text-center"
            [value]="queryAlias"
            (input)="onChangeQueryAliasNo($event.target.value)"
            maxlength="13"
            id="aliasNumber"
            placeholder="XXXXX-XXXXX-X"
          />
        </div>
        <div class="spacer20"></div>
        <a
          type="submit"
          class="btn-primary center-block btn-lg"
          (click)="getCardBalance(queryAlias)"
          [innerHTML]="
            'CARDOPERATIONS_CARD_INPUT_QUERY_BUTTON_LABEL' | translate
          "
        ></a>
      </div>
    </form>
    <form *ngIf="modalState === 'addfav'">
      <div class="text-center">
        <label style="font-size: 30px; font-weight: bold; color: #f2622d"
          >{{ balanceResult }} {{ apiSettings.city.currency }}</label
        >
        <br />
        <br />
        <label>{{ queryAlias }}</label>
        <br />
        <small
          class="text-muted"
          [innerHTML]="'CARDOPERATIONS_CARD_ADDFAV_DETAIL_LABEL1' | translate"
        ></small>
        <small
          class="text-muted"
          [innerHTML]="'CARDOPERATIONS_CARD_ADDFAV_DETAIL_LABEL2' | translate"
        ></small>
        <div class="spacer10"></div>
        <input
          #box
          type="text"
          class="input-lg text-center"
          maxlength="24"
          id="favoriteName"
          [placeholder]="'CARDOPERATIONS_CARD_ADDFAV_PLACEHOLDER' | translate"
        />
      </div>
      <div class="spacer20"></div>
      <a
        type="submit"
        class="btn-primary center-block btn-lg"
        (click)="addtoFavorite(box.value)"
        [innerHTML]="'CARDOPERATIONS_CARD_ADDFAV_BUTTON_LABEL' | translate"
      ></a>
    </form>
    <form *ngIf="modalState === 'result'">
      <div class="text-center">
        <label style="color: green">{{ queryAlias }}</label>
        <small
          class="text-muted"
          [innerHTML]="'CARDOPERATIONS_CARD_RESULT_DETAIL_LABEL1' | translate"
        ></small>
        <label style="color: green">{{ addFavName }}</label>
        <small
          class="text-muted"
          [innerHTML]="'CARDOPERATIONS_CARD_RESULT_DETAIL_LABEL2' | translate"
        ></small>
        <small
          *ngIf="addFavCardResult === true"
          style="color: green"
          [innerHTML]="'CARDOPERATIONS_CARD_RESULT_DETAIL_LABEL3' | translate"
        ></small>
        <small
          *ngIf="addFavCardResult === false"
          style="color: red"
          [innerHTML]="'CARDOPERATIONS_CARD_RESULT_DETAIL_LABEL4' | translate"
        ></small>
        <div class="spacer20"></div>
        <a
          type="submit"
          class="btn-primary center-block btn-lg"
          (click)="onCloseModal()"
          [innerHTML]="'CARDOPERATIONS_CARD_RESULT_OK_BUTTON' | translate"
        ></a>
      </div>
    </form>
</div>